/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeHealthCertificationExtractionStatus = {
    NotStarted: 'not_started',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed',
} as const;
export type HomeHealthCertificationExtractionStatus = typeof HomeHealthCertificationExtractionStatus[keyof typeof HomeHealthCertificationExtractionStatus];


export function instanceOfHomeHealthCertificationExtractionStatus(value: any): boolean {
    for (const key in HomeHealthCertificationExtractionStatus) {
        if (Object.prototype.hasOwnProperty.call(HomeHealthCertificationExtractionStatus, key)) {
            if (HomeHealthCertificationExtractionStatus[key as keyof typeof HomeHealthCertificationExtractionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HomeHealthCertificationExtractionStatusFromJSON(json: any): HomeHealthCertificationExtractionStatus {
    return HomeHealthCertificationExtractionStatusFromJSONTyped(json, false);
}

export function HomeHealthCertificationExtractionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationExtractionStatus {
    return json as HomeHealthCertificationExtractionStatus;
}

export function HomeHealthCertificationExtractionStatusToJSON(value?: HomeHealthCertificationExtractionStatus | null): any {
    return value as any;
}

export function HomeHealthCertificationExtractionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): HomeHealthCertificationExtractionStatus {
    return value as HomeHealthCertificationExtractionStatus;
}

